import React from 'react';
import { NavLink } from 'react-router-dom';

class Section extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      this.section.classList.add("active");
    }, 100);
  }
  render() {
    return (
      <section ref={(el) => this.section = el}>
        {
          this.props.children
        }
      </section>
    )
  }
}

export default Section;
